import styled, { css } from 'styled-components'
import { ThemeColors } from 'src/shared/ui/consts-styles'

export const Wrapper = styled.div`
    & > div {
        margin-top: 0.5rem;
    }

    & > div:first-child {
        margin-top: 0;
    }
`
export const RowContainer = styled.div`
    display: flex;
    align-items: center;
`

export const IconContainer = styled.div`
    max-width: 24px;
    max-height: 24px;
    display: flex;
    align-items: center;
    margin-right: 0.4rem;
`

export const RowContainerBody = styled.div`
    display: flex;
    flex-direction: column;
    ${(props) =>
        !props.isValid &&
        css`
            color: ${ThemeColors.getRedheadColor()};

            &::placeholder {
                color: ${ThemeColors.getRedheadColor()};
            }
        `}
`
export const Icon = styled.img`
    height: auto;
    width: 100%;
`
